<template>
  <tr @click="handleRowClick(row)" class="cursor-pointer">
    <td class="px-0" style="padding-left: 10px; padding-right: 0; width: 58px"><span class="text-xs opacity-20">{{ row.id }}</span></td>
    <td><span class="table-inside__responsive-name">{{ row.name }}</span></td>
    <td>
      <span>{{ row.stage === 'fx' || !row.price ? '–' : toCurrency(row.price, currency) }}</span>
    </td>
    <td v-html="formatDate(row.dateClosed)">

    </td>
  </tr>
</template>

<script>
import Helper from '@/classes/helper'
import Color from '@/classes/color'
import { mapState, mapStores } from 'pinia/dist/pinia'
import { useTasksStore } from '@/stores/tasks'
import { useFinStore } from '@/stores/fin'

export default {
  name: 'TaskRowArchive',
  emits: ['row-click'],
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapStores(useTasksStore),
    ...mapState(useFinStore, ['currency']),
  },
  methods: {
    toCurrency: Helper.toCurrency,
    hexToRGBA: Color.hexToRGBA,
    adjustHexColor: Color.adjustHexColor,
    handleRowClick(item) {
      this.$emit('row-click', item)
    },
    formatDate(isoString) {
      // Создаем объект Date из ISO строки
      const date = new Date(isoString);

      // Определяем локаль пользователя
      const locale = navigator.language;

      // Форматируем дату и время в соответствии с локалью пользователя
      const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false // Используйте 24-часовой формат
      };

      let resultDate = new Intl.DateTimeFormat(locale, options).format(date)
      let split = resultDate.split(',')

      return `${split[0]} <span class="opacity-30">${split[1]}</span>`
    }
  }
}
</script>
